module.exports = __webpack_public_path__ + "static/media/mp.9742dfee.jpeg";